export default __webpack_public_path__ + "static/media/wrong.b61028b2.mp3";